export const getStudents = (ljId, data, classrooms) => {
  const assignmentStatuses = data.filter(d => d.learningJourneyId === ljId && d.needsAttention);
  const students = [];
  if (assignmentStatuses.length > 0) {
    const studentIds = assignmentStatuses.map(val => val.studentProfileId);
    for (const classroom of classrooms) {
      for (const group of classroom.groups) {
        for (const student of group.students) {
          if (studentIds.indexOf(student.id) !== -1 && !students.find(s => s.id === student.id)) {
            students.push({ id: student.id, firstName: student.firstName, lastName: student.lastName });
          }
          if (students.length === assignmentStatuses.length) {
            return students;
          }
        }
      }
    }
  }
  return students;
};

export default getStudents;
